import React from "react";
import Image from "../../image/Image";
import "./Buttons.scss";
import Iconify from "../../../layouts/components/iconify/iconify";

function Buttons(props) {
  const {
    titleText,
    isLoading,
    buttonTypeClassName = "",
    className = "",
    onClick,
    textWithIcon,
    buttonText,
    imagePath,
    isDisable,
    fontIcon,
    iconName,
  } = props;

  const isRefreshIcon =
    typeof iconName === "string" && iconName.toLowerCase().includes("refresh");
  const showSpinningRefresh =
    Boolean(isLoading && textWithIcon && fontIcon && isRefreshIcon);

  return (
    <button
      type="submit"
      className={`btn ${buttonTypeClassName} ${className} ${isDisable ? "disable-btn" : ""} ${isLoading ? "loading-btn" : ""}`.trim()}
      onClick={onClick}
      disabled={isDisable || isLoading}
      title={titleText}
    >
      {showSpinningRefresh ? (
        <div className="button-icon-spin" aria-hidden="true">
          <Iconify icon={iconName} />
        </div>
      ) : isLoading ? (
        <div className="button-loading-part"></div>
      ) : (
        <>
          {textWithIcon && (
            <>
              {fontIcon ? (
                <div>
                  <Iconify icon={iconName}/>
                </div>
              ) : null}
              {imagePath ? (
                <Image
                  imgCustomClassName="front-btn-img"
                  imagePath={imagePath}
                  altText="button Icon"
                />
              ) : null}
            </>
          )}
          <span>{textWithIcon && buttonText}</span>
          {!textWithIcon && buttonText}
        </>
      )}
    </button>
  );
}

export default Buttons;

// import React from "react";
// import Image from "../../image/Image";
// import "./Buttons.scss";
// import { Button } from "@mui/material";

// function Buttons(props) {
//   const {
//     titleText,
//     isLoading,
//     buttonTypeClassName,
//     onClick,
//     textWithIcon,
//     buttonText,
//     imagePath,
//     isDisable,
//     ...muiProps // Capture any other props passed to the Button
//   } = props;

//   return (
//     <Button
//       className={`btn ${buttonTypeClassName} ${isDisable ? "disable-btn" : ""}`}
//       onClick={onClick}
//       disabled={isDisable}
//       title={titleText}
//       type="submit"
//       variant="contained"
//       style={{
//         background: "linear-gradient(to right, #00A3E3, #0072FF)",
//         color: "white",
//         textTransform: "none",
//         fontWeight: 400,
//         fontSize: "14px",
//         borderRadius: "5px",
//         padding: "6px 10px",
//         height: "32px",
//       }}
//       {...muiProps}
//     >
//       {isLoading ? (
//         <div className="button-loading-part"></div>
//       ) : (
//         <>
//           {textWithIcon && <Image imagePath={imagePath} altText="button Icon" />}
//           <span>{textWithIcon && buttonText}</span>
//           {!textWithIcon && buttonText}
//         </>
//       )}
//     </Button>
//   );
// }

// export default Buttons;
